import {StatusCallAccountSummaryModel} from '../../model/status-calls/status-call-account-summary.model';
import {StatusCallLedgerEntryModel} from '../../model/status-calls/status-call-ledger-entry.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace StatusCallAccountController {
  export type QueryLedgerRes = {
    total: number
    items: StatusCallLedgerEntryModel[]
  }

  export const getStatusCallAccount = async (organizationId: string) =>
    (await axios.get<StatusCallAccountSummaryModel>(`/internal/status-calls/accounts/${organizationId}`)).data

  export type GrantHoursReq = {
    hours: number
    comment?: string | null
  }

  export const grantStatusCallHours = async (organizationId: string, request: GrantHoursReq) =>
    (await axios.post(`/internal/status-calls/accounts/${organizationId}/grant`, request))

  export const queryStatusCallLedger = async (organizationId: string, searchable: Searchable) =>
    (await axios.put<QueryLedgerRes>(`/internal/status-calls/accounts/${organizationId}/ledger`, searchable)).data
}
